export default "__VITE_ASSET__DWBWKFG0__"